import PropertyType from '@/components/leads/enums/valuation/PropertyType'
import PropertySubType from '@/components/leads/enums/valuation/PropertySubType'
import { i18n } from '@/plugins/i18n'

const localizedMap = (baseKey, keys) => Object.defineProperties({}, Object.fromEntries(keys.map(key => [
  key,
  { enumerable: true, get: () => i18n.t(`${baseKey}.${key}`) }
])))

export const readablePropertyType = localizedMap('enums.propertyTypes.type', Object.values(PropertyType))

export const readablePropertySubType = localizedMap('enums.propertyTypes.subType', Object.values(PropertySubType))
